/**
 * Options partagées par le formulaire d'inscription et les routes serveur.
 *
 * La question « Comment m'avez-vous connu ? » est déclarative : elle complète
 * la source technique détectée automatiquement (paramètres d'URL, référent),
 * qui ne dit rien d'un flyer ou d'un bouche-à-oreille. Les deux informations
 * sont conservées séparément dans le classeur.
 */
export const DECLARED_SOURCE_OPTIONS = [
  { value: 'reseaux-sociaux', label: 'Réseaux sociaux (Instagram, Facebook…)' },
  { value: 'flyer', label: 'Flyer ou affiche' },
  { value: 'bouche-a-oreille', label: 'Bouche à oreille' },
  { value: 'site-internet', label: 'Site internet ou recherche Google' },
  { value: 'youtube', label: 'YouTube' },
  { value: 'autre', label: 'Autre' },
] as const

export type DeclaredSource = (typeof DECLARED_SOURCE_OPTIONS)[number]['value']

const DECLARED_SOURCE_VALUES = DECLARED_SOURCE_OPTIONS.map((option) => option.value) as readonly string[]

/** Renvoie la valeur retenue si elle fait partie des réponses proposées, sinon une chaîne vide. */
export function normalizeDeclaredSource(value: unknown): DeclaredSource | '' {
  if (typeof value !== 'string') return ''
  const candidate = value.trim().toLowerCase()
  return DECLARED_SOURCE_VALUES.includes(candidate) ? (candidate as DeclaredSource) : ''
}

/** Libellé lisible enregistré dans le classeur et affiché dans l'espace de suivi. */
export function declaredSourceLabel(value: unknown): string {
  const normalized = normalizeDeclaredSource(value)
  if (!normalized) return ''
  return DECLARED_SOURCE_OPTIONS.find((option) => option.value === normalized)?.label ?? ''
}

/** Version de la mention acceptée : conservée avec la date pour pouvoir la prouver. */
export const NEWSLETTER_CONSENT_VERSION = 'Conférence 2026'

/**
 * Valeur écrite dans la colonne de consentement.
 *
 * Vide si la personne n'a pas coché la case ; sinon date exacte du consentement
 * et version de la mention affichée, ce qui constitue la preuve attendue en cas
 * de contrôle.
 */
export function newsletterConsentValue(optIn: boolean, date = new Date()) {
  if (!optIn) return ''
  return `Oui|${date.toISOString()}|${NEWSLETTER_CONSENT_VERSION}`
}

/** Date du consentement, extraite de la valeur stockée dans le classeur. */
export function newsletterConsentDate(value: string) {
  if (!value.startsWith('Oui|')) return ''
  const parts = value.split('|')
  return parts[1] ?? ''
}